import React, { useEffect, useState } from "react";
import "@/App.css";
import { api, clearAuth, getUser } from "@/lib/api";
import { HeaderBar, Footer } from "@/components/Header";
import AuthPage from "@/pages/AuthPage";
import ConsolePage from "@/pages/ConsolePage";
import HistoryPage from "@/pages/HistoryPage";
import InboxPage from "@/pages/InboxPage";

export default function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState("console");
  const [currentRunId, setCurrentRunId] = useState(null);
  const [bootChecked, setBootChecked] = useState(false);

  useEffect(() => {
    const cached = getUser();
    if (!cached) { setBootChecked(true); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => clearAuth())
      .finally(() => setBootChecked(true));
    // One-shot bootstrap; imports are stable references.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function logout() {
    clearAuth();
    setUser(null);
    setCurrentRunId(null);
    setView("console");
  }

  function nav(v) { setView(v); if (v === "console") {/* keep run */} }

  if (!bootChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono text-sm text-[#A8B3C7]">
        booting · · ·
      </div>
    );
  }

  if (!user) return <AuthPage onAuthed={setUser} />;

  return (
    <div className="App min-h-screen">
      <HeaderBar
        user={user}
        onLogout={logout}
        onNav={nav}
        view={view}
      />
      {view === "console" && (
        <ConsolePage
          initialRunId={currentRunId}
          onOpenRun={(id) => setCurrentRunId(id)}
          onOpenInbox={() => setView("inbox")}
        />
      )}
      {view === "history" && (
        <HistoryPage
          onOpenRun={(id) => { setCurrentRunId(id); setView("console"); }}
        />
      )}
      {view === "inbox" && (
        <InboxPage
          onOpenRun={(id) => { setCurrentRunId(id); setView("console"); }}
        />
      )}
      <Footer />
    </div>
  );
}
